const MIME_TYPE_ICONS: Readonly<Record<string, string>> = {
  'image/jpeg': 'image',
  'image/png': 'image',
  'image/gif': 'image',
  'image/svg+xml': 'image',
  'audio/mpeg': 'audiotrack',
  'audio/wav': 'audiotrack',
  'video/mp4': 'video_library',
  'video/webm': 'video_library',
  'application/pdf': 'picture_as_pdf',
  'application/zip': 'archive',
};

export function getFileIcon(mimeType: string): string {
  return MIME_TYPE_ICONS[mimeType] ?? 'description';
}
